import _ from 'lodash'

const keyToDescriptionMap: Record<string, string> = {
  allPurchases: "All purchases",
  dining: "Dining",
  gas: "Gas",
  grocery: "Grocery",
  streaming: "Streaming",
  drugstore: "Drugstore",
  fitness: "Fitness",
  takeout_delivery: "Takeout and delivery",
  office_supplies: "Office supplies",
  internet_cable_phone: "Internet, cable, and phone",
  "travel.general": "Travel",
  "travel.airline.general": "Travel booked with airlines",
  "travel.airline.united": "United flights",
  "travel.airline.delta": "Delta flights",
  "travel.airline.american": "American flights",
  "travel.airline.southwest": "Southwest flights",
  "travel.airline.alaska": "Alaska flights",
  "travel.airline.hawaiian": "Hawaiian airlines flights",
  "travel.airline.frontier": "Frontier flights",
  "travel.rideshare": "Rideshare",
  "travel.hotel.general": "Hotel stays",
  "travel.hotel.best_western": "Best Western hotel stays",
  "travel.hotel.choice": "Choice hotel stays",
  "travel.hotel.hyatt": "Hyatt hotel stays",
  "travel.hotel.ihg": "IHG hotel stays",
  "travel.hotel.wyndham": "Wyndham hotel stays",
  "travel.hotel.marriott_bonvoy": "Marriott Bonvoy hotel stays",
  "travel.hotel.hilton": "Hilton hotel stays",
  "travel.transit": "Transit",
};

export function formatSpendCategory(key: string): string {
  return keyToDescriptionMap[key] || _.capitalize(key);
}